import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { UserRouteAccessService } from 'src/app/core';
import { Observable } from 'rxjs';
import { LoadingTypeMySuffix } from 'src/app/shared/model/loading-type-my-suffix.model';
import { LoadingTypeMySuffixService } from './loading-type-my-suffix.service';
import { LoadingTypeMySuffixComponent } from './loading-type-my-suffix.component';
import { LoadingTypeMySuffixDetailComponent } from './loading-type-my-suffix-detail.component';
import { LoadingTypeMySuffixUpdateComponent } from './loading-type-my-suffix-update.component';
import { LoadingTypeMySuffixDeletePopupComponent } from './loading-type-my-suffix-delete-dialog.component';
import { ILoadingTypeMySuffix } from 'src/app/shared/model/loading-type-my-suffix.model';

import { LoadingTypeDto, ILoadingTypeDto } from 'src/app/shared/model/loading-type-my-suffix.model';

@Injectable({ providedIn: 'root' })
export class LoadingTypeMySuffixResolve implements Resolve<ILoadingTypeDto> {
    constructor(private service: LoadingTypeMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            return this.service.find(id).map((loadingType: HttpResponse<LoadingTypeDto>) => loadingType.body);
        }
        return Observable.of(new LoadingTypeDto());
    }
}

export const loadingTypeRoute: Routes = [
    {
        path: 'loading-type',
        component: LoadingTypeMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'LoadingTypes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'loading-type/:id/view',
        component: LoadingTypeMySuffixDetailComponent,
        resolve: {
            loadingType: LoadingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'LoadingTypes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'loading-type/new',
        component: LoadingTypeMySuffixUpdateComponent,
        resolve: {
            loadingType: LoadingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'LoadingTypes'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'loading-type/:id/edit',
        component: LoadingTypeMySuffixUpdateComponent,
        resolve: {
            loadingType: LoadingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'LoadingTypes'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const loadingTypePopupRoute: Routes = [
    {
        path: 'loading-type/:id/delete',
        component: LoadingTypeMySuffixDeletePopupComponent,
        resolve: {
            loadingType: LoadingTypeMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'LoadingTypes'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
